import { render, staticRenderFns } from "./ReturnRequests.vue?vue&type=template&id=00c2c887&"
import script from "./ReturnRequests.vue?vue&type=script&lang=js&"
export * from "./ReturnRequests.vue?vue&type=script&lang=js&"
import style0 from "./ReturnRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports